import { Footer } from "../footer";
import { WhiskymofoOneColumnFooter } from "./WhiskymofoOneColumnFooter";

const WHISKYMOFO_ENABLED = process.env.GATSBY_ENABLE_WHISKYMOFO === "true";

type PageFooterProps = {
  footerLayout?: string;
  isWhiskymofo?: boolean;
};

export const PageFooter = ({
  footerLayout,
  isWhiskymofo,
}: PageFooterProps): JSX.Element => {
  const layout = WHISKYMOFO_ENABLED
    ? isWhiskymofo
      ? footerLayout || "Whiskymofo footer"
      : footerLayout || "Default footer"
    : "Default footer";
  switch (layout) {
    case "Whiskymofo one column footer":
      return <WhiskymofoOneColumnFooter />;
    case "Whiskymofo footer":
      return <Footer isWhiskymofo={true} />;
    case "Default footer":
    default:
      return <Footer />;
  }
};
